const ADDRESS_KEY = "chafadi-addresses";

export const getAddresses = () => {
  try {
    return JSON.parse(localStorage.getItem(ADDRESS_KEY) || "[]");
  } catch (error) {
    return [];
  }
};

export const setAddresses = (addresses) => {
  localStorage.setItem(ADDRESS_KEY, JSON.stringify(addresses));
  window.dispatchEvent(new Event("chafadi-addresses-updated"));
};

export const addAddress = (address) => {
  const existing = getAddresses();
  const next = [
    ...existing,
    {
      id: Date.now(),
      label: address.label || "Address",
      full_name: address.full_name || "",
      phone: address.phone || "",
      line1: address.line1 || "",
      line2: address.line2 || "",
      city: address.city || "",
      region: address.region || "",
      postal_code: address.postal_code || "",
      country: address.country || "Niger",
      is_default: existing.length === 0 || !!address.is_default,
    },
  ].map((item, index, array) =>
    address.is_default && item.id !== array[array.length - 1].id
      ? { ...item, is_default: false }
      : item
  );
  setAddresses(next);
};

export const removeAddress = (id) => {
  const remaining = getAddresses().filter((address) => address.id !== id);
  if (remaining.length > 0 && !remaining.some((address) => address.is_default)) {
    remaining[0].is_default = true;
  }
  setAddresses(remaining);
};

export const setDefaultAddress = (id) => {
  setAddresses(
    getAddresses().map((address) => ({
      ...address,
      is_default: address.id === id,
    }))
  );
};
